import LateralMotionTransition from "./LateralMotionTransition";
import BottomRotationTransition from "./BottomRotationTransition";
import LateralMotionInverseTransition from "./LateralMotionInverseTransition";
import SingleRightTransition from './SingleRightTransition'
import SingleRightInverseTransition from './SingleRightInverseTransition'
import SingleLeftInverseTransition from './SingleLeftInverseTransition'
import VoidCenterTransition from './VoidCenterTransition'
import TriangleMotionTransition from "./TriangleMotionTransition";
import setVideoRatio from "../scripts/setVideoRatio";
import VerticalSlider from "./VerticalSlider";

class TransitionManager {

    constructor() {
        this.lastTransition = null;
        this.sliderTransitions = [];
        this.slider = null;
        this.transitions = {
            lateralMotion: LateralMotionTransition,
            bottomRotation: BottomRotationTransition,
            lateralMotionInverse: LateralMotionInverseTransition,
            singleRight: SingleRightTransition,
            singleRightInverse: SingleRightInverseTransition,
            voidCenter: VoidCenterTransition,
            singleLeftInverse: SingleLeftInverseTransition,
            triangleMotion: TriangleMotionTransition
        };

        setVideoRatio();
        this.playPageTransition();
        this.slider = new VerticalSlider();
    }

    /**
     * @deprecated
     */
    playHomepage() {
        this.playPageTransition();
    }

    restartSlider() {
        this.sliderTransitions = [];
        if( this.slider ) {
            this.slider.destroy();
        }
        this.slider = null;
    }

    playPageTransition( elem = false ) {
        elem = ( elem ) ? elem : document;
        elem = elem.querySelector('.animation');
        let animation = elem.dataset.transition;
        let transition = this.buildTransition(animation, elem, true);
        if( document.querySelector('.vertical-slider') ) {
            this.setSlideTransition(this.sliderTransitions.length, transition);
        } else {
            this.lastTransition = transition;
        }
    }

    getSlideTransition(index, type = null, autoplay = false) {

        if (this.slideHasTransition(index)) {
            let transition = this.sliderTransitions[index];
            if (autoplay) {
                transition.play();
            }
            return transition;
        }

        if (type !== null) {
            let elem = document.querySelectorAll('.slide')[index];
            let transition = this.buildTransition(type, elem, autoplay);
            this.setSlideTransition(this.sliderTransitions.length, transition);
            return transition;
        }
        return false;
    }

    slideHasTransition(index) {
        return this.sliderTransitions[index]
    }

    setSlideTransition(index, tl) {
        this.sliderTransitions.splice(index, 0, tl);
        this.lastTransition = tl;
    }

    buildTransition(type, elem, autoplay = false) {
        if (this.transitions[type] === undefined) {
            throw new Error('Transition not supported on: ' + elem.id);
        }
        return new this.transitions[type](elem, autoplay);
    }

}

export default TransitionManager;